var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomattribute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 164",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.971,
    height: 10.219,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17145",
    fill: "#185edf",
    stroke: "#707070",
    d: "M0 0h10.219v10.219H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37072"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1380",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17144",
    fill: "none",
    d: "M0 0h10.219v10.219H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37071",
    fill: "#185edf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21469",
    d: "m8.558 6.216 1.171-.319a4.9 4.9 0 0 0 0-1.575l-1.171-.32a.383.383 0 0 1-.234-.554l.596-1.064a4.386 4.386 0 0 0-1.086-1.085l-1.064.6-.17.043a.383.383 0 0 1-.383-.277L5.897.49a4.9 4.9 0 0 0-1.575 0l-.32 1.171a.383.383 0 0 1-.383.277l-.17-.043-1.065-.596a4.386 4.386 0 0 0-1.085 1.085l.6 1.064a.383.383 0 0 1-.234.554l-1.171.319a4.9 4.9 0 0 0 0 1.575l1.171.319a.383.383 0 0 1 .234.554l-.6 1.064A4.386 4.386 0 0 0 2.384 8.92l1.064-.6.17-.043a.383.383 0 0 1 .383.277l.319 1.171a4.9 4.9 0 0 0 1.575 0l.319-1.171a.383.383 0 0 1 .386-.27l.17.043 1.064.6A4.386 4.386 0 0 0 8.92 7.834l-.6-1.064a.383.383 0 0 1 .234-.554Zm-.255-.832H8.26a1.3 1.3 0 0 0-.724.7 1.213 1.213 0 0 0 .021 1.022h.021v.043l.319.532a.639.639 0 0 1-.17.17l-.532-.319h-.063a1.15 1.15 0 0 0-.532-.128 1.277 1.277 0 0 0-1.192.83v.064l-.192.639h-.213l-.17-.617v-.036a1.277 1.277 0 0 0-1.213-.852 1.15 1.15 0 0 0-.532.128h-.065l-.532.319a.639.639 0 0 1-.17-.17l.319-.532v-.045h.021a1.213 1.213 0 0 0 .023-1.022 1.3 1.3 0 0 0-.724-.7h-.065l-.617-.192v-.215l.617-.17h.064a1.3 1.3 0 0 0 .724-.7 1.213 1.213 0 0 0-.021-1.022H2.64v-.045l-.319-.532.17-.17.532.319h.061a1.15 1.15 0 0 0 .532.128 1.277 1.277 0 0 0 1.195-.827v-.068l.192-.639h.213l.168.618v.043a1.277 1.277 0 0 0 1.216.846 1.15 1.15 0 0 0 .532-.128h.064l.532-.319a.639.639 0 0 1 .17.17l-.319.532v.045h-.021a1.213 1.213 0 0 0-.021 1.022 1.3 1.3 0 0 0 .724.7h.063l.617.17v.213l-.617.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21470",
    d: "M5.11 3.193a1.916 1.916 0 1 0 1.916 1.916A1.916 1.916 0 0 0 5.11 3.193Zm0 2.98a1.064 1.064 0 1 1 1.064-1.064A1.064 1.064 0 0 1 5.11 6.174Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon open-sort-descending",
    d: "M10.221 9.453V8.015h5.752v1.438Zm0-2.876V5.14h4.314v1.438Zm0-2.876V2.263h2.876v1.438Z",
    fill: "#185edf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomattribute);
export default __webpack_public_path__ + "static/media/customattribute.f9181f79126f04a49f1026189c81cb68.svg";
export { ForwardRef as ReactComponent };